export default __webpack_public_path__ + "resources/icons/d130-b992.png";